import { ITour } from '../queries';
import { EAppActionTypes, IAppStoreAction } from '../actions'

export default (state: ITour | null, { type, tour }: IAppStoreAction) => {
	switch (type) {
		case EAppActionTypes.SetTour:
			return tour || null
		default:
			return state
	}
}